import { AccountModel, ISelf } from '@models/account';
import '@styles/app.css';
import '@styles/dialog.common.css';
import { useEffect, useState, withHooks } from 'blx-react-hooks';
import * as React from 'react';
import '@weike/components/lib/dist/components.css';

// 初始化 global bus
import WKPage from '@components/WKPage';
import { AccountContext } from '@services/context';
import { globalBusContext, GlobalBusEvents } from '@services/global-bus';
import Bus from '@services/lib/bus';
import '@weike/weike-ui/lib/weike-ui.css';

const globalBus = new Bus<GlobalBusEvents>();
const GlobalBusProvider = globalBusContext.Provider;

export default withHooks(function app({
  children
}: {
  children?: React.ReactChild | React.ReactChild[];
}) {
  const [fetchSelf, setFetchSelf] = useState<ISelf | null>(null);

  useEffect(() => {
    AccountModel.fetchSelf().then((self) => {
      setFetchSelf(self);
    });
  }, []);

  if (!fetchSelf) {
    return null;
  }

  return (
    <AccountContext.Provider value={fetchSelf}>
      <GlobalBusProvider value={globalBus}>
        <WKPage>{children}</WKPage>
      </GlobalBusProvider>
    </AccountContext.Provider>
  );
});



// WEBPACK FOOTER //
// ./src/App.tsx